import React, { useRef, useEffect } from 'react';
import { View, Animated, Dimensions, Easing, ViewPropTypes, Platform } from 'react-native'

import { isFunction as _isFunction, isNil as _isNil } from 'lodash';
import PropTypes from 'prop-types';

import { getRTLValue } from '../../Utils/RTL';
import { useTheme, LightThemeColors } from '../Themes';

import TabItem from './TabItem';
import styles from './VFHeaderTabs.styles';

function VFHeaderTabs({
  activeTab,
  setActiveTab,
  tabs,
  allowFontScaling,
  activeTabTextStyle,
  inActiveTabTextStyle,
  navigate = () => { },
  containerStyle,
}) {
  // const lineAnimation = useRef(new Animated.Value(0));
  // const { width } = Dimensions.get('screen');
  // const lineWidth = tabs && tabs.length ? width / tabs.length : 0;
  const theme = useTheme() || LightThemeColors;
  const { width } = Dimensions.get('window')
  const _lineWidth = Platform.OS === 'web' && Dimensions.get('window').width > 700 ? tabs && tabs.length ? (width - 300) / tabs.length : 0 : tabs && tabs.length ? width / tabs.length : 0
  const lineWidth = _lineWidth
  const lineAnimation = useRef(new Animated.Value(activeTab * lineWidth))

  useEffect(() => {
    !_isNil(activeTab) && handleLineAnimation(activeTab);
  }, [activeTab]);

  const handleOnPress = index => {
    _isFunction(setActiveTab) && setActiveTab(index);
    _isFunction(navigate) && (Platform.OS === 'web' && Dimensions.get('window').width > 700) && navigate()
    handleLineAnimation(index);
  };

  const handleLineAnimation = index => {
    Animated.timing(lineAnimation.current, {
      toValue: getRTLValue(lineWidth * index),
      duration: 200,
      easing: Easing.linear,
      useNativeDriver: true,
    }).start();
  };

  const tabsList =
    tabs && tabs.length
      ? tabs.map((tab, _i) => {
        return (
          <TabItem
            key={tab.index}
            tabStyle={styles.tab(theme)}
            activeTab={activeTab}
            handleOnPress={handleOnPress}
            tab={tab}
            allowFontScaling={allowFontScaling}
            activeTextStyle={activeTabTextStyle}
            inActiveTextStyle={inActiveTabTextStyle}
          />
        );
      })
      : null;

  return (
    <View style={[styles.container, styles.containerTopColor(theme), containerStyle]}>
      {tabsList}
      <Animated.View
        style={[
          styles.activeLine,
          styles.activeTabBackgroundColorColor(theme),
          {
            width: lineWidth,
            transform: [
              {
                translateX: lineAnimation.current,
              },
            ],
          },
        ]}
      />
    </View>
  );
}

VFHeaderTabs.defaultProps = {
  activeTab: 0,
  tabs: [],
  setActiveTab: () => { },
};

VFHeaderTabs.propTypes = {
  activeTab: PropTypes.number,
  setActiveTab: PropTypes.func,
  tabs: PropTypes.array,
  allowFontScaling: PropTypes.bool,
  activeTabTextStyle: ViewPropTypes.style,
  inActiveTabTextStyle: ViewPropTypes.style,
  containerStyle: ViewPropTypes.style,
};

export default VFHeaderTabs;
